module.exports = __webpack_public_path__ + "static/img/C (15).42be27d9.png";